import { Link } from "react-router-dom";
import { Play, Lock, Archive } from "lucide-react";

export const VideoCard = ({ video, index = 0, compact = false }) => {
  const thumb = video.thumb_url || (video.youtube_id ? `https://img.youtube.com/vi/${video.youtube_id}/hqdefault.jpg` : null);
  const streamable = video.available === true || !!video.embed_provider || !!video.youtube_id;
  const unavailable = !streamable;
  const sourceIssue = streamable && video.source_status && video.source_status !== "Available";
  const primaryArea = Array.isArray(video.areas_of_study) ? video.areas_of_study[0] : null;
  return (
    <Link
      to={`/watch/${video.id}`}
      data-testid={`video-card-${video.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <div className="relative aspect-video overflow-hidden border border-white/10 bg-[#121418]">
        {thumb ? (
          <img src={thumb} alt={video.title} loading="lazy" decoding="async"
            className="w-full h-full object-cover object-center opacity-90 group-hover:opacity-100 group-hover:scale-[1.04] transition-all duration-500 ease-out" />
        ) : streamable ? (
          <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#1a1d24] to-[#0f1115]">
            <Play size={26} className="text-[#C5A059]" strokeWidth={1.5} />
            <span className="text-[9px] tracking-[0.25em] uppercase text-[#8A8F98]">{video.embed_provider === "facebook" ? "Facebook Video" : video.embed_provider === "instagram" ? "Instagram Video" : "Video"}</span>
          </div>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-[#4a4f57] gap-2 bg-[#0f1115]">
            <Archive size={26} strokeWidth={1.5} />
            <span className="text-[9px] tracking-[0.25em] uppercase text-[#5a5f67]">Archival Record</span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B0E]/90 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity duration-300" />
        {!unavailable && (
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-14 h-14 rounded-full bg-[#C5A059] flex items-center justify-center shadow-lg">
              <Play size={20} className="text-[#0A0B0E] ml-1" fill="#0A0B0E" />
            </div>
          </div>
        )}
        {video.year && (
          <span className="absolute top-3 left-3 text-[10px] tracking-widest uppercase bg-[#0A0B0E]/85 text-[#C5A059] px-2 py-1">
            {video.year}
          </span>
        )}
        {unavailable ? (
          <span className="absolute bottom-3 right-3 text-[10px] tracking-wide bg-[#0A0B0E]/85 text-[#8A8F98] px-2 py-0.5 border border-white/10">
            Not yet online
          </span>
        ) : sourceIssue ? (
          <span data-testid={`source-status-${video.id}`} className="absolute bottom-3 right-3 text-[10px] tracking-wide bg-[#0A0B0E]/85 text-[#C08A3E] px-2 py-0.5 border border-[#C08A3E]/40">
            {video.source_status === "Under review" ? "Under review" : "Source unavailable"}
          </span>
        ) : video.duration ? (
          <span className="absolute bottom-3 right-3 text-xs bg-[#0A0B0E]/85 text-[#EBE9E1] px-2 py-0.5 tabular-nums">
            {video.duration}
          </span>
        ) : null}
      </div>
      <div className={compact ? "pt-3" : "pt-4"}>
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#8A8F98] mb-1.5">{video.content_type || video.subject || "Archive"}</p>
        <h3 className={`font-serif text-[#EBE9E1] leading-snug group-hover:text-[#C5A059] transition-colors ${compact ? "text-lg" : "text-xl"}`}>
          {video.title}
        </h3>
        {!compact && (
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mt-1.5 text-sm text-[#8A8F98]">
            {primaryArea && <span className="text-[#C5A059]/80">{primaryArea}</span>}
            {primaryArea && video.location && <span className="text-[#3a3f47]">·</span>}
            {video.location && <span>{video.location}</span>}
          </div>
        )}
      </div>
    </Link>
  );
};
